
export const BREAKPOINTS_VALUES = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
} as const;

export const MEDIA_QUERIES = {
  xs: "(min-width: 0px)",
  sm: "(min-width: 600px)",
  md: "(min-width: 960px)",
  lg: "(min-width: 1280px)",
  xl: "(min-width: 1920px)",
  
  xsOnly: "(max-width: 599px)",
  smOnly: "(max-width: 959px)",
  mdOnly: "(max-width: 1279px)",
  lgOnly: "(max-width: 1919px)",
  
  smToMd: "(min-width: 600px) and (max-width: 959px)",
  mdToLg: "(min-width: 960px) and (max-width: 1279px)",
} as const;

export const BREAKPOINTS_INFO = {
  xs: { name: "Extra Small", width: "0-599px", example: "Mobile phones" },
  sm: { name: "Small", width: "600-959px", example: "Tablets in portrait" },
  md: { name: "Medium", width: "960-1279px", example: "Tablets in landscape" },
  lg: { name: "Large", width: "1280-1919px", example: "Desktop" },
  xl: { name: "Extra Large", width: "1920px+", example: "Large desktop/TV" },
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS_VALUES;














